module.exports = __webpack_public_path__ + "static/media/petrol.6b8f903d.svg";